import gsap from 'gsap';
import Dispatch from '../core/Dispatch';
import { COMPONENT_INIT } from '../lib/events';

export default el => {

    let observer;
    let activeImage = [...el.querySelectorAll('[data-image]')][0];
    let zIndex = 2;

    const setActiveImage = image => {
        if (image === activeImage) {
            return;
        }
        zIndex += 1;
        image.hidden = false;
        image.style.zIndex = zIndex;
        gsap.fromTo(image, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.3,
            ease: 'Quad.easeOut'
        });
        activeImage = image;
    };

    const onLinkMouseEnter = e => {
        const { entryId } = e.target.dataset;
        const image = el.querySelector(`[data-image][data-entry-id="${entryId}"]`);
        if (!image) {
            const defaultImage = el.querySelector('[data-image=""]');
            if (defaultImage) {
                setActiveImage(defaultImage);
            }
            return;
        }

        setActiveImage(image);
    };

    const onLinkMouseLeave = () => {
        const defaultImage = el.querySelector('[data-image=""]');
        if (defaultImage) {
            setActiveImage(defaultImage);
        }
    };

    const init = () => {
        el.querySelectorAll('a[data-entry-id]').forEach(a => {
            a.addEventListener('mouseenter', onLinkMouseEnter);
            a.addEventListener('mouseleave', onLinkMouseLeave);
            a.addEventListener('focusin', onLinkMouseEnter);
            a.addEventListener('focusout', onLinkMouseLeave);
        });

        observer = new IntersectionObserver(([{ isIntersecting }]) => {
            if (!isIntersecting) {
                return;
            }
            el.querySelectorAll('[data-image] .lazyload').forEach(image => {
                image.classList.add('lazypreload');
            });
            observer.disconnect();
            observer = null;
        });
        observer.observe(el);

        Dispatch.emit(COMPONENT_INIT);
    };

    const destroy = () => {
        el.querySelectorAll('a[data-entry-id]').forEach(a => {
            a.removeEventListener('mouseenter', onLinkMouseEnter);
            a.removeEventListener('mouseleave', onLinkMouseLeave);
            a.removeEventListener('focusin', onLinkMouseEnter);
            a.removeEventListener('focusout', onLinkMouseLeave);
        });

        if (observer) {
            observer.disconnect();
            observer = null;
        }
    };

    return {
        init,
        destroy
    };

};
